var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Timeline extends Component {
    constructor() {
        super('Timeline', false);
        this.currentIndex = 0;
        this.startYear = 0;
        this.endYear = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.module-timeline').length > 0) {
                this.currentIndex = $('.module-timeline-event-image.is-highlighted').index();
                this.startYear = parseInt($('.module-timeline-timeline p').first().text());
                this.endYear = parseInt($('.module-timeline-timeline p').last().text());
                $('.module-timeline .btn-prev-event').on('click', (event) => {
                    event.preventDefault();
                    this.prev();
                });
                $('.module-timeline .btn-next-event').on('click', (event) => {
                    event.preventDefault();
                    this.next();
                });
                $('.module-timeline-event-image').on('click', (event, image) => {
                    event.preventDefault();
                    this.goto(image.index());
                });
                $(window).on('resize', () => {
                    this.computeHeight();
                });
                this.computeHeight();
                this.updateIndicatorPosition();
            }
            this.success();
        });
    }
    goto(index) {
        this.currentIndex = index;
        $('.module-timeline-event-image').removeClass('is-highlighted');
        $('.module-timeline-event-image').eq(this.currentIndex).addClass('is-highlighted');
        $('.module-timeline-event-text').addClass('d-none');
        $('.module-timeline-event-text').eq(this.currentIndex).removeClass('d-none');
        $('.module-timeline-event-image video').each((video) => {
            video.addClass('d-none');
            video.get(0).pause();
        });
        const video = $('.module-timeline-event-image').eq(this.currentIndex).find('video');
        if (video.length > 0) {
            video.removeClass('d-none');
            video.get(0).currentTime = 0;
            video.get(0).play();
        }
        $('.module-timeline-current-year').text($('.module-timeline-event-image').eq(this.currentIndex).data('year'));
        this.updateIndicatorPosition();
    }
    next() {
        this.currentIndex++;
        if (this.currentIndex >= $('.module-timeline-event-image').length)
            this.currentIndex = $('.module-timeline-event-image').length - 1;
        this.goto(this.currentIndex);
    }
    prev() {
        this.currentIndex--;
        if (this.currentIndex < 0)
            this.currentIndex = 0;
        this.goto(this.currentIndex);
    }
    computeHeight() {
        //$('.module-timeline-event-container').css('height', $('.module-timeline-event-image.is-highlighted').height());
    }
    updateIndicatorPosition() {
        /*const currentYear = parseInt($('.module-timeline-event-image.is-highlighted').data('year'));
        const percentage = (currentYear - this.startYear) / (this.endYear - this.startYear);*/
        const percentage = $('.module-timeline-event-image.is-highlighted').index() * 100 / ($('.module-timeline-event-image').length - 1);
        $('.module-timeline-timeline-indicator').css('left', `calc(${percentage}% - 5px)`);
    }
}
